import { ModelSagres } from "@/types/model-sagres";
import { RespostaAvaliacao, RespostaAvaliacaoJson } from "./resposta-avaliacao";

export class RetornoRespostaAvaliacao extends ModelSagres {
  respostaAvaliacaos: RespostaAvaliacao[];
  respostaAvaliacaoJson: RespostaAvaliacaoJson[];

  /**
   * @param obj
   */
  constructor(obj?: RespostaAvaliacaoJson[]) {
    super();
    if (obj) {
      this.respostaAvaliacaos = obj.map((data: RespostaAvaliacaoJson) => new RespostaAvaliacao(data));
      this.respostaAvaliacaoJson = [...obj]
    }
  }
}
